import React from "react";
import { Route } from "react-router-dom";
import TestimonialsList from "./testimonials.list";
import TestimonialEdit from "./testimonial.edit";
import TestimonialNew from "./testimonial.new";

import { UsersListProvider } from "./usersListProvider";

const TestimonialsRouter = ({ match }) => (
  <UsersListProvider>
    <Route path={`${match.path}/:type/new`} component={TestimonialNew} />
    <Route path={`${match.path}/:type/:id/edit`} component={TestimonialEdit} />
    <Route exact path={`${match.path}/:type`} component={TestimonialsList} />
  </UsersListProvider>
);

export default TestimonialsRouter;
